import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_25 = {
  key: 0,
  class: "ui-card ui-mt-30"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Regiões")
      ])
    ])
  ])
], -1)
const _hoisted_27 = { class: "ui-card-body" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_30 = {
  key: 1,
  class: "ui-card ui-mt-30"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Estados")
      ])
    ])
  ])
], -1)
const _hoisted_32 = { class: "ui-card-body" }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_35 = { class: "ui-card ui-mt-30" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Aplicação da Regra")
      ])
    ])
  ])
], -1)
const _hoisted_37 = { class: "ui-card-body" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_caixa_selecao = _resolveComponent("caixa-selecao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_tipo_clientes = _resolveComponent("combo-tipo-clientes")!
  const _component_combo_finalidade_produtos = _resolveComponent("combo-finalidade-produtos")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_combo_regiao = _resolveComponent("combo-regiao")!
  const _component_combo_estado = _resolveComponent("combo-estado")!
  const _component_combo_aplicacao_regra_preco = _resolveComponent("combo-aplicacao-regra-preco")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Tipo da Regra")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_caixa_selecao, {
                      opcoes: _ctx.state.opcoesCaixaSelacao,
                      valor: _ctx.state.regraPreco.tipo,
                      "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.regraPreco.tipo) = $event))
                    }, null, 8, ["opcoes", "valor"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.regraPreco.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.regraPreco.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.regraPreco.status,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.regraPreco.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, { label: "Data Ínicio" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          "data-selecionada": _ctx.state.regraPreco.dataInicio,
                          "onUpdate:dataSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.regraPreco.dataInicio) = $event))
                        }, null, 8, ["data-selecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Data Fim" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          "data-selecionada": _ctx.state.regraPreco.dataFim,
                          "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.regraPreco.dataFim) = $event))
                        }, null, 8, ["data-selecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Tipo de Clientes" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_tipo_clientes, {
                          valor: _ctx.state.regraPreco.tipoCliente,
                          "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.regraPreco.tipoCliente) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, { label: "Finalidade da Compra" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_finalidade_produtos, {
                          valor: _ctx.state.regraPreco.finalidadeProdutos,
                          "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.regraPreco.finalidadeProdutos) = $event)),
                          apresentarAmbos: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Descrição")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.regraPreco.descricao,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.regraPreco.descricao) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            (_ctx.state.regraPreco.tipo === _ctx.ETipoRegraPreco.Regiao)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_combo_regiao, {
                          multiplaSelecao: true,
                          codigos: _ctx.state.regioesSelecionadas,
                          "onUpdate:codigos": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.regioesSelecionadas) = $event))
                        }, null, 8, ["codigos"])
                      ])
                    ])
                  ])
                ]))
              : (_ctx.state.regraPreco.tipo === _ctx.ETipoRegraPreco.Estado)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_combo_estado, {
                            multiplaSelecao: true,
                            codigos: _ctx.state.estadosSelecionados,
                            "onUpdate:codigos": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.estadosSelecionados) = $event))
                          }, null, 8, ["codigos"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_a_form_item, { label: "Escolha um opção" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_aplicacao_regra_preco, {
                          valor: _ctx.state.regraPreco.aplicacao,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.regraPreco.aplicacao) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_a_form_item, { label: "Valor" }, {
                      default: _withCtx(() => [
                        ((_ctx.state.regraPreco.aplicacao === _ctx.EAplicacaoRegraPreco.AcrescimoValor || _ctx.state.regraPreco.aplicacao === _ctx.EAplicacaoRegraPreco.DescontoValor))
                          ? (_openBlock(), _createBlock(_component_campo_numerico, {
                              key: 0,
                              monetario: true,
                              valor: _ctx.state.regraPreco.valor,
                              "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.regraPreco.valor) = $event))
                            }, null, 8, ["valor"]))
                          : ((_ctx.state.regraPreco.aplicacao === _ctx.EAplicacaoRegraPreco.AcrescimoPercentual || _ctx.state.regraPreco.aplicacao === _ctx.EAplicacaoRegraPreco.DescontoPercentual))
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 1,
                                percentual: true,
                                valor: _ctx.state.regraPreco.valor,
                                "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.regraPreco.valor) = $event))
                              }, null, 8, ["valor"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}